export const AUTH_SESSION_MISSING = 'AUTH_SESSION_MISSING'
export const SESSION_EXPIRED_MESSAGE = 'Your session has expired'
export const SESSION_EXPIRED_REASON = 'session_expired'

/**
 * A valid Alvie session exists, but the request is missing user context (the
 * `userEmail` cookie) that Flow BFF routes require to forward `X-Alvie-User-Email`.
 * Distinct from `AUTH_SESSION_MISSING` so the client does not treat it as an
 * expired session and log an otherwise-authenticated user out.
 */
export const AUTH_USER_CONTEXT_MISSING = 'AUTH_USER_CONTEXT_MISSING'
export const USER_CONTEXT_MISSING_MESSAGE = 'Missing user context for this request'
